import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import { withRouter } from 'react-router-dom';
import { debounce } from "lodash";

import Stars from '../../../Common/Stars';
import { LoadingIcon } from '../../../Common/Loading_Icon';

import Select from 'react-select';
import { setProfileDb } from '../../../../Actions/dataActions';
import { setList } from '../../../../Actions/stakeholderActions';
import { Trans } from 'react-i18next';<Trans></Trans>

class InternalTagOverlay extends Component {
    constructor(props) {    
        super(props);

        this.submitinternaltag = debounce(this.submitinternaltag.bind(this), 500);
        this.updateinternaltagForm = this.updateinternaltagForm.bind(this);
        this.loadDivisions = this.loadDivisions.bind(this);
        this.loadVMHs = this.loadVMHs.bind(this);
        this.updateOEM = this.updateOEM.bind(this);
        this.updateDivision = this.updateDivision.bind(this);
        this.updateVMH = this.updateVMH.bind(this);

        this.state = {
            internaltag_details: {},
            form_details: {},
            loaded_internaltag: true,
            action: "",
            edit: false,
            internaltag_form: {name: "", description: "", tag_oem_id: null, tag_sh_id: null, tag_vmh_id: null},
            selectedOEM: null, selectedDivision: null, selectedVMH: null
        };

        //
    }

    componentDidMount() {        
         if (this.props.match.params.tag_id !== "new") {
            if (this.props.match.params.tag_id != undefined && this.props.match.params.action == "edit") {
                var self = this;
                axios.get( "ajax/internaltag/" + this.props.match.params.tag_id + "/edit")
                .then(function(response) {
                    self.state.internaltag_form.name = response?.data.view.name;
                    self.state.internaltag_form.description = response?.data.view.desc;
                    self.setState({
                        form_details: response?.data.view,
                        action: response?.data.action,
                        loaded_internaltag: false
                    })
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }

                    if (self.props.closeModal) self.props.closeModal();
                })
            }
        }
        else {
             axios.get('/ajax/internaltag/create')
            .then((response) => {
                if(response?.data.view.sh_id == -9 && response?.data.view.divisions.length == 1)
                {
                    this.loadVMHs(response?.data.view.divisions[0].SH_ID);
                    this.state.internaltag_form.tag_sh_id = response?.data.view.divisions[0].SH_ID;
                }

                if(response?.data.view.oem_id != -9)
                {
                    this.state.internaltag_form.tag_oem_id = response?.data.view.oem_id;
                }

                if(response?.data.view.sh_id != -9)
                {
                    this.state.internaltag_form.tag_sh_id = response?.data.view.sh_id;
                }

                if(response?.data.view.vmh_id != -9)
                {
                    this.state.internaltag_form.tag_vmh_id = response?.data.view.vmh_id;
                }

                this.setState({
                    form_details: response?.data.view,
                    action: response?.data.action,
                    loaded_internaltag: false
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
    }

    loadDivisions(value) {
        axios.post('/ajax/stakeholder/' + value + '/options', {
                'filter': 'oem_with_booking',
            })
            .then((response) => {
                let newState = Object.assign({}, this.state);
                newState.form_details.divisions = response?.data.stakeholders;

                if(newState.selectedDivision != null)
                {
                    newState.selectedDivision = null;
                    newState.internaltag_form["invite_sh_id"] = null;
                }

                if(newState.selectedVMH != null)
                {
                    newState.selectedVMH = null;
                    newState.internaltag_form["invite_vmh_id"] = null;
                }

                this.setState(newState);
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    loadVMHs(value) {
        axios.post('/ajax/vmh/' + value + '/options', {
                'filter': 'oem_with_booking',
            })
            .then((response) => {
                let newState = Object.assign({}, this.state);
                newState.form_details.vmhs = response?.data.vmhs;

                if(newState.selectedVMH != null)
                {
                    newState.selectedVMH = null;
                    newState.internaltag_form["invite_vmh_id"] = null;
                }

                this.setState(newState);
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    submitinternaltag(event) {
        event.preventDefault();

        var self = this;
        var url = "/ajax/internaltag";
        
        if(this.state.form_details.primary_button_action == "update")
        {
            var url = "/ajax/internaltag/" + this.props.match.params.tag_id + "/update";
        }

        axios({
            method: 'post',
            url: url,
            data: this.state.internaltag_form,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        .then((response) => {
            //handle success
            if(this.state.form_details.primary_button_action == "update")
            {
                var profile_db = self.props.data.profile_db
                profile_db[self.props.match.params.tag_id].First_Name = self.state.internaltag_form.name
                self.props.dispatch(setProfileDb([], profile_db));
                
                var user_list = self.props.stakeholder.user_list
                for (var i = 0; i < user_list.length; i++) {
                    if (user_list[i].ID === self.props.match.params.tag_id) {
                        user_list[i].First_Name = self.state.internaltag_form.name
                    }
                }
                self.props.dispatch(setList("SET_USER_LIST", user_list))

                if(self.props.match.url.split("/")[1] === "useroverview") {
                    var data = {
                        search_term: self.props.stakeholder.previous_filters.search,
                        sort_filter: self.props.stakeholder.sort_filter,
                        sort_direction: self.props.stakeholder.sort_direction,
                        bookings_min: self.props.stakeholder.previous_filters.bookings.min,
                        bookings_max: self.props.stakeholder.previous_filters.bookings.max,
                        last_booking_min: self.props.stakeholder.previous_filters.last_booking.min,
                        last_booking_max: self.props.stakeholder.previous_filters.last_booking.max,
                        member_min: self.props.stakeholder.previous_filters.member.min,
                        member_max: self.props.stakeholder.previous_filters.member.max
                    }
    
    
                    var filters = self.props.stakeholder.previous_filters;
                    var categories = Object.keys(filters);
                    for (var i = 0; i < categories.length; i++) {
                        data[categories[i]] = "";
                        if (categories[i] !== "bookings" || categories[i] !== "last_booking" || categories[i] !== "member") {
                            var items = Object.keys(filters[categories[i]]);
                            for (var k = 0; k < items.length; k++) {
                                if (filters[categories[i]][items[k]] === true) {
                                    if (data[categories[i]] === "") {
                                        data[categories[i]] = items[k]
                                    } else {
                                        data[categories[i]] = data[categories[i]] + "#" + items[k]
                                    }
                                }
                            }
                        }
                    }
    
                    axios({
                        method: 'post',
                        url: '/ajax/user_list/update',
                        data: data
                    })
                    .then(function(response2) {
                        self.props.dispatch(setProfileDb(response2.data.data.data, self.props.data.profile_db));
                        self.props.dispatch(setList("SET_USER_LIST", response2.data.data.data))
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
    
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
    
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
                }

            } else {
                if(self.props.match.url.split("/")[1] === "useroverview") {
                    var data = {
                        search_term: self.props.stakeholder.previous_filters.search,
                        sort_filter: self.props.stakeholder.sort_filter,
                        sort_direction: self.props.stakeholder.sort_direction,
                        bookings_min: self.props.stakeholder.previous_filters.bookings.min,
                        bookings_max: self.props.stakeholder.previous_filters.bookings.max,
                        last_booking_min: self.props.stakeholder.previous_filters.last_booking.min,
                        last_booking_max: self.props.stakeholder.previous_filters.last_booking.max,
                        member_min: self.props.stakeholder.previous_filters.member.min,
                        member_max: self.props.stakeholder.previous_filters.member.max
                    }
    
    
                    var filters = self.props.stakeholder.previous_filters;
                    var categories = Object.keys(filters);
                    for (var i = 0; i < categories.length; i++) {
                        data[categories[i]] = "";
                        if (categories[i] !== "bookings" || categories[i] !== "last_booking" || categories[i] !== "member") {
                            var items = Object.keys(filters[categories[i]]);
                            for (var k = 0; k < items.length; k++) {
                                if (filters[categories[i]][items[k]] === true) {
                                    if (data[categories[i]] === "") {
                                        data[categories[i]] = items[k]
                                    } else {
                                        data[categories[i]] = data[categories[i]] + "#" + items[k]
                                    }
                                }
                            }
                        }
                    }
    
                    axios({
                        method: 'post',
                        url: '/ajax/user_list/update',
                        data: data
                    })
                    .then(function(response2) {
                        self.props.dispatch(setProfileDb(response2.data.data.data, self.props.data.profile_db));
                        self.props.dispatch(setList("SET_USER_LIST", response2.data.data.data))
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
    
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
    
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
                }
            }
            
            showStatusMsg(response?.data.message, 'success');
            self.props.history.goBack();
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    updateinternaltagForm(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var internaltag_form = this.state.internaltag_form;
        internaltag_form[name] = value;

        this.setState({
            internaltag_form: internaltag_form
        });
    }

    updateOEM(option) {
        var internaltag_form = this.state.internaltag_form;
        internaltag_form["tag_oem_id"] = option.value;

        this.setState({
            internaltag_form: internaltag_form,
            selectedOEM: option
        });

        this.loadDivisions(option.value);
    }

    updateDivision(option) {
        var internaltag_form = this.state.internaltag_form;
        internaltag_form["tag_sh_id"] = option.value;

        this.setState({
            internaltag_form: internaltag_form,
            selectedDivision: option
        });

        this.loadVMHs(option.value); 
    }

    updateVMH(option) {
        var internaltag_form = this.state.internaltag_form;
        internaltag_form["tag_vmh_id"] = option.value;

        this.setState({
            internaltag_form: internaltag_form,
            selectedVMH: option
        });
    }

    componentWillReceiveProps(nextProps) {
    }

    render(props) {
        return (
            <div id = "internaltaguser-overlay" className= "small-overlay">
                <div className = "card no-margin">
                    <div className = "card-divider">
                        <span className = "card-header-title"><Trans>Internal Tag</Trans></span>
                        <button className="close-button"  onClick={this.props.history.goBack} type='button'>
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    </div>
                    {
                        !this.state.loaded_internaltag && this.state.action == "create" && (this.state.form_details.oem_id == -9 || this.state.form_details.sh_id == -9 || this.state.form_details.vmh_id == -9) ?
                            <div className = "card-divider">
                                {
                                    !this.state.loaded_internaltag && this.state.action == "create" && (this.state.form_details.oem_id == -9 || this.state.form_details.sh_id == -9) ?
                                        <div className = "row collapse mb-16">
                                            {
                                                !this.state.loaded_internaltag && this.state.form_details.oem_id == -9 ?
                                                    <div className = "columns large-6 medium-6 small-12" >
                                                        <label>OEM <span className = "red-alert">*</span>
                                                            <div className = "form-95">
                                                                <Select 
                                                                    options={
                                                                        !this.state.loaded_invite ?
                                                                            this.state.form_details.oems.map((oem, i) =>
                                                                               ({
                                                                                label:oem.option, value:oem.value
                                                                               })
                                                                            )
                                                                        :
                                                                        ([{
                                                                            label:'N/A', value:''
                                                                        }])
                                                                    } 
                                                                    onChange={this.updateOEM}
                                                                    value={this.state.selectedOEM}
                                                                    style={{width: "100%",height:'36px'}}
                                                                    className="react_select_dropdown"
                                                                    classNamePrefix="react_select"
                                                                />
                                                            </div>
                                                        </label>
                                                    </div>
                                                :
                                                    null
                                            }
                                            {
                                                !this.state.loaded_internaltag && this.state.form_details.sh_id == -9 ?
                                                    <div className = "columns large-6 medium-6 small-12" >
                                                        <label><Trans>Pool</Trans> <span className = "red-alert">*</span>
                                                            <div className = "form-95">
                                                                <Select 
                                                                    options={
                                                                        !this.state.loaded_invite ?
                                                                            this.state.form_details.divisions.map((division, i) =>
                                                                               ({
                                                                                label: division.option, value:division.value
                                                                               })
                                                                            )
                                                                        :
                                                                        ([{
                                                                            label:'N/A', value:''
                                                                        }])
                                                                    } 
                                                                    onChange={this.updateDivision}
                                                                    value={this.state.selectedDivision}
                                                                    style={{width: "100%",height:'36px'}}
                                                                    className="react_select_dropdown"
                                                                    classNamePrefix="react_select"
                                                                />
                                                            </div>
                                                        </label>
                                                    </div>
                                                :
                                                    null
                                            }
                                        </div>
                                    :
                                        null
                                }
                                {
                                    !this.state.loaded_internaltag && this.state.action == "create" ?
                                        <div className = "row collapse mb-16">
                                            <div className = "columns large-6 medium-6 small-12">
                                                <label><Trans>Assigned Facility</Trans> <span className = "red-alert">*</span>
                                                    <div className = "form-95">
                                                        <Select 
                                                            options={
                                                                this.state.form_details.vmhs.map((vmh, i) =>
                                                                   ({
                                                                    label:vmh.option, value:vmh.value
                                                                   })
                                                                )
                                                            } 
                                                            onChange={this.updateVMH}
                                                            value={this.state.selectedVMH}
                                                            style={{width: "100%",height:'36px'}}
                                                            className="react_select_dropdown"
                                                            classNamePrefix="react_select"
                                                        />
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    :
                                        null
                                }
                            </div>
                        :
                            null
                    }
                    <div className = "card-divider">
                        <div className = "row collapse">
                            <div className = "columns large-6 medium-6 small-12">
                                <label><Trans>Name</Trans> <span className = "red-alert">*</span>
                                    {
                                        !this.state.loaded_internaltag ?
                                            <input type = "text" name = "name" className = "form-text form-95" defaultValue={this.state.form_details.name} onChange={this.updateinternaltagForm}/>
                                        :
                                            null
                                    }
                                </label>
                            </div>
                        </div>
                        <div className = "row collapse">
                            <div className = "columns large-12 medium-12 small-12">
                                <label><Trans>Description</Trans>
                                    {
                                        !this.state.loaded_internaltag ?
                                            <textarea className = "big-textarea" placeholder="Describe what this tag is used for" name="description" onChange={this.updateinternaltagForm} defaultValue={this.state.form_details.desc}></textarea>
                                        :
                                            null
                                    }
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className = "card-section">
                        <div className = "button-group float-right">
                            <a className = "button mr-8" onClick={this.props.history.goBack}><Trans>Cancel</Trans></a>
                            <a className = "button primary" onClick={(event) => { this.submitinternaltag(event)}}>{ this.state.form_details.primary_button }</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(InternalTagOverlay)